import { GetServerSidePropsContext } from 'next'

import { Device, DeviceOs } from '#/shared/lib/types/entities'

/**
 * @deprecated
 */
export const getTypeDevice = (context: GetServerSidePropsContext): Device => {
	const UA = context.req.headers['user-agent']

	if (!UA) {
		return 'desktop'
	}

	const isMobile = Boolean(UA.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))

	return isMobile ? 'mobile' : 'desktop'
}

export const getDeviceType = (): Device => {
	const UA = navigator.userAgent

	if (!UA) {
		return 'desktop'
	}

	const isMobile = Boolean(UA.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))

	return isMobile ? 'mobile' : 'desktop'
}

/**
 * @deprecated
 */
export const getDeviceOs = (context: GetServerSidePropsContext): DeviceOs => {
	const UA = context.req.headers['user-agent']

	if (!UA) {
		return 'android'
	}

	const isIos = UA.includes('iPhone') || UA.includes('iPad')

	return isIos ? 'ios' : 'android'
}

export const getOs = (): DeviceOs => {
	const UA = navigator.userAgent

	if (!UA) {
		return 'android'
	}

	const isIos = UA.includes('iPhone') || UA.includes('iPad')

	return isIos ? 'ios' : 'android'
}
